import React, { useEffect, useState } from "react";
import Cross from "../../../../images/cross.svg";
import Fire from "../../../../images/confetti.png";
import { TBrand } from "../../../../types";

import "./GuessingField.component.scss";

type Props = {
  inputData: string;
  currentGame: TBrand | undefined;
};

/* ----- Main Component ----- */
const GuessingField = (props: Props) => {
  const [emojiClass, setEmojiClass] = useState<string>("");

  const { inputData, currentGame } = props;

  useEffect(() => {
    if (inputData !== "") setEmojiClass("guessing-field__emoji-animation");
  }, [inputData]);

  return (
    <div className="guessing-field">
      <div
        className={`guessing-field__emoji ${
          currentGame?.name === inputData ? "guessing-field__win" : ""
        }`}
      >
        <img
          src={
            inputData !== ""
              ? currentGame?.name === inputData
                ? Fire
                : Cross
              : ""
          }
          alt=""
          className={emojiClass}
        />
      </div>

      <input
        type="text"
        value={inputData}
        disabled
        className={`guessing-field__field ${
          currentGame?.name === inputData ? "guessing-field__win" : ""
        }`}
      />
    </div>
  );
};

export default GuessingField;
